import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4444 10H6.55556C5.69645 10 5 10.8954 5 12V19C5 20.1046 5.69645 21 6.55556 21H17.4444C18.3036 21 19 20.1046 19 19V12C19 10.8954 18.3036 10 17.4444 10Z",
			stroke: "#A7B0BE",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9V6.57143C8 5.62423 8.42143 4.71582 9.17157 4.04605C9.92172 3.37627 10.9391 3 12 3C13.0609 3 14.0783 3.37627 14.8284 4.04605C15.5786 4.71582 16 5.62423 16 6.57143V9",
			stroke: "#A7B0BE",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 13,
			width: 2,
			height: 4,
			rx: 1,
			fill: "#A7B0BE"
		})
	]
});
export { SvgLock as ReactComponent };
export { default } from "/home/runner/work/frontend_insights/frontend_insights/apps/insights/src/assets/images/svg/lock.svg?url";
